import { render, staticRenderFns } from "./AIFeedbackButtons.vue?vue&type=template&id=61b2a926&scoped=true"
import script from "./AIFeedbackButtons.vue?vue&type=script&lang=js"
export * from "./AIFeedbackButtons.vue?vue&type=script&lang=js"
import style0 from "./AIFeedbackButtons.vue?vue&type=style&index=0&id=61b2a926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2a926",
  null
  
)

export default component.exports